import BaseModelAPI from '../BaseModelAPI';

export default class PurchaseOrderAttachment extends BaseModelAPI {
	static entity = 'purchaseorderattachment';
	static entityName = 'purchaseorderattachment';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.purchaseOrderId = '';
			this.purchaseOrder = {};
			this.poAttachmentId = '';
			this.poAttachment = {};
			this.remarks = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}